<template>
    <el-row class="content_wrap">
        <el-row>
            <el-col :span="24"><div class="grid-content bg-purple-dark u_qiaosui_header"><i class="el-icon-s-order"></i>桥隧详情</div></el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <div class="grid-content bg-purple-dark u_suidao_title_c">
                    <el-tabs v-model="activeName" @tab-click="handleClick">
                        <el-tab-pane label="机电设备" name="first">
                            <!-- 安全状况 && 分项故障率 && 维修决策 -->
                            <el-row :gutter="20">
                                <el-col :span="24">
                                    <div class="grid-content bg-purple u_suidao_bg1" style="padding-bottom: 10px;">
                                        <el-row>
                                            <el-col :span="24">
                                                <div class="grid-content bg-purple" style="padding:12px;text-align:left;">
                                                    <span style="color:#7F7F7F;font-size:14px;">请选择年月：</span>
                                                    <el-date-picker v-model="monthVal" type="month" placeholder="选择月" value-format="yyyy-M" @change="getMonthVal"></el-date-picker>
                                                </div>
                                            </el-col>
                                        </el-row>
                                        <el-row :gutter="20">
                                            <el-col :span="8">
                                                <div class="grid-content bg-purple" style="height:370px;background: #fff;border-radius: 5px;">
                                                    <div class="u_suidao_title">安全状况</div>
                                                    <div id="myChart01" style="width:100%;height:240px;"></div>
                                                    <el-row>
                                                        <el-col :span="12"><div class="u_suidao_score" v-if="this.monthStateList != undefined">技术评分：{{jspfData}}</div></el-col>
                                                        <el-col :span="12"><div class="u_suidao_score" id="u_zt_bgcolor" v-if="this.monthStateList != undefined">服役状态：{{this.monthStateList.serviceStatusName}}</div></el-col>
                                                    </el-row>
                                                </div>
                                            </el-col>
                                            <el-col :span="8">
                                                <div class="grid-content bg-purple" style="height:370px;background: #fff;border-radius: 5px;">
                                                    <div class="u_suidao_title">分项故障率</div>
                                                    <div id="myChart02" style="width:100%;height:300px;"></div>
                                                </div>
                                            </el-col>
                                            <el-col :span="8">
                                                <div class="grid-content bg-purple" style="height:370px;background: #fff;border-radius: 5px;">
                                                    <div class="u_suidao_title">维修决策</div>
                                                    <el-row>
                                                        <el-col :span="24" style="text-align:center;">
                                                            <div id="u_suidao_state"><img src="../../assets/img/anquan.png" alt=""></div>
                                                        </el-col>
                                                    </el-row>
                                                    <div class="u_suidao_anquan" id="u_suidao_anquan">无需维修</div>
                                                </div>
                                            </el-col>
                                        </el-row>
                                    </div>
                                </el-col>
                            </el-row>
                            <!-- 数据统计分析 -->
                            <el-row :gutter="20">
                                <el-col :span="24">
                                    <div class="grid-content bg-purple u_suidao_bg1" style="padding-bottom: 10px;">
                                        <div class="u_suidao_title">数据统计分析</div>
                                        <el-row>
                                            <el-col :span="24">
                                                <div class="grid-content bg-purple" style="padding:12px;text-align:left;margin-bottom: 10px;">
                                                    <span style="color:#7F7F7F;font-size:14px;">请选择年：</span>
                                                    <el-date-picker v-model="yearVal" type="year" placeholder="选择月" value-format="yyyy" @change="getYearVal"></el-date-picker>
                                                </div>
                                            </el-col>
                                        </el-row>
                                        <el-row :gutter="20">
                                            <el-col :span="10">
                                                <div class="grid-content bg-purple" style="background: #fff;padding-top:8px;border:1px solid #EBEEF5;">
                                                    <div id="myChart03" style="width:100%;height:550px;"></div>
                                                </div>
                                            </el-col>
                                            <el-col :span="14">
                                                <div class="grid-content bg-purple u_suidao_table">
                                                    <el-table :data="tableData" max-height="560" id="tableDataRefresh">
                                                        <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
                                                        <el-table-column align="center" label="分项故障率 %">
                                                            <el-table-column prop="ventilationFaultRate" align="center" label="通风设施" width=""></el-table-column>
                                                            <el-table-column prop="lightingFaultRate" align="center" label="照明设施" width=""></el-table-column>
                                                            <el-table-column prop="waterSupplyDrainageFaultRate" align="center" label="给排水设施" width=""></el-table-column>
                                                            <el-table-column prop="weakCurrentFaultRate" align="center" label="弱电设施" width=""></el-table-column>
                                                            <el-table-column prop="powerSupplyFaultRate" align="center" label="供配电设施" width=""></el-table-column>
                                                            <el-table-column prop="fireFightingFaultRate" align="center" label="消防设施" width=""></el-table-column>
                                                        </el-table-column>
                                                        <el-table-column prop="technicalScore" align="center" label="技术状况评分" width=""></el-table-column>
                                                        <el-table-column prop="serviceStatusName" align="center" label="服役状态" width=""></el-table-column>
                                                        <el-table-column prop="decision" align="center" label="维修决策" width="150"></el-table-column>
                                                        <el-table-column prop="dateTime" align="center" label="时间范围" width=""></el-table-column>
                                                    </el-table>
                                                </div>
                                            </el-col>
                                        </el-row>
                                    </div>
                                </el-col>
                            </el-row>
                            <!-- 设备实时状态 -->
                            <el-row :gutter="20">
                                <el-col :span="24">
                                    <div class="grid-content bg-purple u_suidao_bg1">
                                        <div class="u_suidao_title">设备实时状态</div>
                                        <el-row :gutter="20" style="padding: 20px;">
                                            <el-col :span="24">
                                                <div class="grid-content bg-purple u_suidao_table">
                                                    <el-table :data="messageList" max-height="600" border>
                                                        <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
                                                        <el-table-column prop="systemType" align="center" label="系统" width=""></el-table-column>
                                                        <el-table-column prop="sDevTypeDesc" align="center" label="字系统" width=""></el-table-column>
                                                        <el-table-column prop="instrumentName" align="center" label="关键设备" width=""></el-table-column>
                                                        <el-table-column prop="location" align="center" label="位置" width=""></el-table-column>
                                                        <el-table-column prop="statusName" align="center" label="当前状态" width="">
                                                            <template slot-scope="scope">
                                                                <span style="color:#03B615;" v-if="scope.row.statusName === '正常'">{{scope.row.statusName}}</span>
                                                                <span style="color:red;" v-else>{{scope.row.statusName}}</span>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column prop="dateTime" align="center" label="获取时间" width=""></el-table-column>
                                                    </el-table>
                                                </div>
                                            </el-col>
                                        </el-row>
                                    </div>
                                </el-col>
                            </el-row>
                        </el-tab-pane>
                        <el-tab-pane label="土建结构" name="second">
                            <el-row :gutter="20">
                                <el-col :span="8">
                                    <div class="grid-content bg-purple u_suidao_bg1" style="height:400px;">
                                        <div class="u_suidao_title">不良区段占比</div>
                                        <div id="myChart04" style="width:100%;height:280px;"></div>
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="grid-content bg-purple u_suidao_bg1" style="height:400px;">
                                        <div class="u_suidao_title">服役状态</div>
                                        <div id="myChart05" style="width:100%;height:280px;"></div>
                                        <el-row>
                                            <el-col :span="24"><div class="u_suidao_fuyi">危险</div></el-col>
                                        </el-row>
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="grid-content bg-purple u_suidao_bg1" style="height:400px;">
                                        <div class="u_suidao_title">维修决策</div>
                                        <el-row>
                                            <el-col :span="24" style="text-align:center;"><img src="../../assets/img/dange.png"></el-col>
                                        </el-row>
                                        <div class="u_suidao_dange">抢险后立即大修</div>
                                    </div>
                                </el-col>
                            </el-row>
                        </el-tab-pane>
                        <el-tab-pane label="保护区监测" name="third">
                            保护区监测
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </el-col>
        </el-row>
    </el-row>
</template>

<script>
import $ from 'jquery'
import * as echarts from 'echarts'
import { mapState,mapMutations } from 'vuex'
export default {
    name: 'bridgeDetails',
    data() {
        let newDate = localStorage.getItem('newDate')
        return {
            activeName: 'first',
            monthVal: `${newDate.split('/')[0]}-${newDate.split('/')[1]}`,
            yearVal: `${newDate.split('/')[0]}`,
            tableData: [],
            messageList: [],
            jspfData: ''
        }
    },
    computed: {
        ...mapState([
            'list',
            'monthStateList',
            'yearScoreList'
        ])
    },
    async created() {
        let self = this
        let newDate = localStorage.getItem('newDate')
        // 设备实时状态数据
        await self.$store.dispatch('getSuidaoInfo')
        // 初始化加载本月运行状态数据
        await self.getMonthVal(`${newDate.split('/')[0]}-${newDate.split('/')[1]}`)
        await self.getYearVal(`${newDate.split('/')[0]}`)
        await self.getMessageList()
    },
    mounted: function () {

    },
    methods: {
        // 桥隧详情 => 机电设备 => 安全状况 && 分项故障率
        async getMonthVal(val1){
            const rLoading = this.openLoading()
            $('#myChart01,#myChart02').fadeOut(500)
            $('#myChart01,#myChart02').fadeIn(500)
            let startTime = ''
            if (val1.split('-')[1].length === 1){
                startTime = `${val1.split('-')[0]}-0${val1.split('-')[1]}-01 00:00:00`
            } else {
                startTime = `${val1.split('-')[0]}-${val1.split('-')[1]}-01 00:00:00`
            }
            let endTime = ''
            if (JSON.stringify(val1.split('-')[1] * 1 + 1).length === 1){
                endTime = `${val1.split('-')[0]}-0${val1.split('-')[1] * 1 + 1}-01 00:00:00`
            } else {
                endTime = `${val1.split('-')[0]}-${val1.split('-')[1] * 1 + 1}-01 00:00:00`
            }
            await this.$store.dispatch('getOperationStateInfo', {
                startTime: startTime,
                endTime: endTime
            })
            if (this.monthStateList != undefined){
                this.jspfData = this.monthStateList.technicalScore
                let myCharts01 = echarts.init(document.getElementById(`myChart01`))
                let options01 = {
                    series: [{
                        type: 'gauge',
                        startAngle: 180,
                        endAngle: 0,
                        min: 0,
                        max: 100,
                        splitNumber: 10,
                        radius: '100%',
                        center:['50%', '70%'],
                        axisLine: {
                            lineStyle: {
                                width: 6,
                                color: [
                                    [0.7, 'rgba(91,143,249)'],
                                    [0.9, 'rgba(90,216,166)'],
                                    [1, 'rgba(93,112,146)']
                                ]
                            }
                        },
                        pointer: {
                            offsetCenter: [0, '-30%']
                        },
                        axisLabel: {
                            color: '#464646',
                            fontSize: 12,
                            distance: -45,
                            formatter: function (value) {
                                if (value === 100) {
                                    return '正常'
                                }
                                else if (value === 80) {
                                    return '恶化'
                                }
                                else if (value === 50) {
                                    return '危险'
                                }
                            }
                        },
                        title: {
                            offsetCenter: [0, '-20%'],
                            fontSize: 16
                        },
                        detail: {
                            fontSize: 24,
                            offsetCenter: [0, '2%'],
                            valueAnimation: true,
                            formatter: function (value) {
                                return Math.round(value)
                            }
                        },
                        data: [{
                            name: '分数',
                            value: this.monthStateList.technicalScore
                        }]
                    }]
                };
                // 判断安全状况中的服役状态&&维修决策
                let fuyibgcolor = document.getElementById('u_zt_bgcolor')
                if (this.monthStateList.technicalScore > 90){
                    fuyibgcolor.style.background = 'rgba(129,211,248,1)'
                    document.getElementById('u_suidao_anquan').innerHTML = '无需维修'
                    document.getElementById('u_suidao_anquan').style.color = '#15C727'
                    let div = document.getElementById('u_suidao_state')
                    div.innerHTML = '<img src="/img/anquan.e209084f.png">'
                } else if (this.monthStateList.technicalScore < 90 && this.monthStateList.technicalScore > 80){
                    fuyibgcolor.style.background = 'rgba(218,165,32,0.5)'
                    document.getElementById('u_suidao_anquan').innerHTML = '抢险后立即大修'
                    document.getElementById('u_suidao_anquan').style.color = '#D81E06'
                    let div = document.getElementById('u_suidao_state')
                    div.innerHTML = '<img src="/img/dange.ee23b60a.png">'
                } else if (this.monthStateList.technicalScore < 80){
                    fuyibgcolor.style.background = 'rgba(255,0,0,0.5)'
                }
                // 分项故障率
                let failureRateData = [this.monthStateList.ventilationFaultRate, this.monthStateList.lightingFaultRate,this.monthStateList.waterSupplyDrainageFaultRate,this.monthStateList.weakCurrentFaultRate,this.monthStateList.powerSupplyFaultRate,this.monthStateList.fireFightingFaultRate]
                let myCharts02 = echarts.init(document.getElementById(`myChart02`))
                let options02 = {
                    title: {
                        text: ''
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data: ['故障率'],
                        bottom: "0"
                    },
                    grid: {
                        left: "8%",
                        right: "5%",
                        top: "6%"
                    },
                    xAxis: {
                        type: 'category',
                        data: ['通风设施','照明设施','给排水设施','弱电设施','供配电设施','消防设施'],
                        axisLabel: {
                            interval: 0,
                            rotate: 30
                        }
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        name:'故障率',
                        type: 'bar',
                        barWidth : 20,
                        data: failureRateData
                    }]
                };
                myCharts01.setOption(options01)
                myCharts02.setOption(options02)
                window.addEventListener('resize', function () {
                    myCharts01.resize()
                    myCharts02.resize()
                });
            }
            rLoading.close()
        },
        // 桥隧详情 => 机电设备 => 本年技术评分
        async getYearVal(val){
            const rLoading = this.openLoading()
            $('#myChart03').fadeOut(400)
            $('#myChart03').fadeIn(400)
            $('#tableDataRefresh').fadeOut(400)
            $('#tableDataRefresh').fadeIn(400)
            let startTime = `${JSON.parse(val)}-01-01`
            let endTime = `${JSON.parse(val)+1}-01-01`
            await this.$store.dispatch('getSkillScoreInfo', {
                startTime: startTime,
                endTime: endTime
            })
            this.tableData = []
            let TechnicalGradeArr = new Array()
            this.yearScoreList.forEach(ele => {
                TechnicalGradeArr.push(ele.technicalScore)
                let eleDecision = ''
                if (ele.decision === ''){
                    eleDecision = '无'
                } else {
                    eleDecision = ele.decision
                }
                this.tableData.push({
                    ventilationFaultRate: ele.ventilationFaultRate,
                    lightingFaultRate: ele.lightingFaultRate,
                    waterSupplyDrainageFaultRate: ele.waterSupplyDrainageFaultRate,
                    weakCurrentFaultRate: ele.weakCurrentFaultRate,
                    powerSupplyFaultRate: ele.powerSupplyFaultRate,
                    fireFightingFaultRate: ele.fireFightingFaultRate,
                    technicalScore: ele.technicalScore,
                    serviceStatusName: ele.serviceStatusName,
                    decision: eleDecision,
                    dateTime: ele.dateTime.split('T')[0].substring(0,ele.dateTime.split('T')[0].length-3),
                })
            })
            let myCharts03 = echarts.init(document.getElementById(`myChart03`))
            let options03 = {
                title: {
                    text: '年度技术状况总评分',
                    textStyle: {
                        fontSize: 14
                    },
                    top: '0',
                    left: '4%'
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: '',
                    bottom: "3%"
                },
                grid: {
                    left: "6%",
                    right: "3%",
                    top: "10%"
                },
                xAxis: {
                    type: 'category',
                    data: ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    name:`${val}`,
                    type: 'line',
                    smooth: true,
                    areaStyle: {},
                    data: TechnicalGradeArr
                }]
            };
            myCharts03.setOption(options03)
            window.addEventListener('resize', function () {
                myCharts03.resize()
            });
            rLoading.close()
        },
        // 桥隧详情 => 土建结构 => 不良区段占比
        async getSoilBuilding (){
            let myCharts04 = echarts.init(document.getElementById(`myChart04`))
            let options04 = {
                title: {
                    text: '',
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'vertical',
                    bottom: 'bottom'
                },
                series: [{
                    name: '',
                    type: 'pie',
                    radius: ['40%', '60%'],
                    data: [
                        {value: 135, name: '不良区段'},
                        {value: 1048, name: '非不良区段'}
                    ]
                }]
            };
            // 土建结构 && 服役状态
            let myCharts05 = echarts.init(document.getElementById(`myChart05`))
            let options05 = {
                title: {
                    text: '',
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'vertical',
                    bottom: 'bottom'
                },
                series: [{
                    name: '',
                    type: 'pie',
                    radius: '50%',
                    data: [
                        {value: 150, name: '正常'},
                        {value: 20, name: '恶化'},
                        {value: 10, name: '危险'}
                    ]
                }]
            };
            myCharts04.setOption(options04)
            myCharts05.setOption(options05)
            window.addEventListener('resize', function () {
                myCharts04.resize()
                myCharts05.resize()
            });
        },
        // 桥隧详情tabs
        async handleClick(tab, event){
            this.activeName = tab.name
            if (tab.name === 'second'){
                this.$nextTick(() => {
                    this.getSoilBuilding()
                })
            }
        },
        // 设备实时状态
        async getMessageList() {
            this.list.forEach(ele => {
                this.messageList.push({
                    systemType: ele.systemType,
                    sDevTypeDesc: ele.sDevTypeDesc,
                    instrumentName: ele.instrumentName,
                    location: ele.location,
                    statusName: ele.statusName,
                    dateTime: `${ele.dateTime.split('.')[0].split('T')[0]} ${ele.dateTime.split('.')[0].split('T')[1]}`
                })
            })
        }
    },
}
</script>
